import { render, staticRenderFns } from "./GroupSummary.vue?vue&type=template&id=9ce2ffb0&scoped=true"
import script from "./GroupSummary.vue?vue&type=script&lang=js"
export * from "./GroupSummary.vue?vue&type=script&lang=js"
import style0 from "./GroupSummary.vue?vue&type=style&index=0&id=9ce2ffb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce2ffb0",
  null
  
)

export default component.exports